import React from 'react';
import { Link } from 'react-router-dom';
import { cuisines } from '../../data/taxonomy';

/** Continuous rail of cuisines — pauses on hover and holds still under reduced motion. */
export function CuisineMarquee() {
  const row = [...cuisines, ...cuisines];
  return <section aria-labelledby="cuisine-heading" className="overflow-hidden border-y border-hairline bg-oat py-5" data-id="element-502" data-mp="3mp9q2t41v4jq">
      <h2 id="cuisine-heading" className="sr-only" data-id="element-503" data-mp="4jdkuq9mr1a5">
        Browse by cuisine
      </h2>
      <div className="group flex w-max animate-marquee gap-3 hover:[animation-play-state:paused] focus-within:[animation-play-state:paused]" data-id="element-504" data-mp="3vpy3pmpj72w3">
        {row.map((cuisine, i) => <Link key={`${cuisine.id}-${i}`} to={`/discover?cuisine=${cuisine.id}`} aria-hidden={i >= cuisines.length} tabIndex={i >= cuisines.length ? -1 : 0} className="shrink-0 rounded-full border border-hairline bg-surface px-5 py-2.5 font-display text-[15px] text-ink transition-colors duration-150 ease-out hover:border-primary/50 hover:text-primary" data-id="element-505" data-mp="ebj6zjd7aohf" data-mpi={i}>
            {cuisine.label}
          </Link>)}
      </div>
    </section>;
}